import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';

interface PrintView {
  cardChartWidth?: React.CSSProperties['width'];
  fullChartWidth?: React.CSSProperties['width'];
}

const DEFAULT_VIEW: PrintView = {
  cardChartWidth: '100%',
  fullChartWidth: '100%'
};

export const PrintViewContext = React.createContext<PrintView>(DEFAULT_VIEW);

const PrintViewProvider: React.FC<PrintView> = ({ children, ...printView }): React.ReactElement => {
  const [isPrintView, setIsPrintView] = useState(false);

  useEffect(() => {
    const enablePrintView = (): void => {
      // *Synchronously* flush/update DOM changes inside this event handler so that
      // the components are guaranteed to be flushed before the printing occurs.
      // See: https://github.com/facebook/react/issues/11876#issuecomment-352421144
      //
      // Also note: Pretty sure modifying global state in a handler like this is broken in development
      // mode on React 16 - works fine in production builds, though.
      // See: https://github.com/facebook/react/issues/17918
      ReactDOM.flushSync(() => {
        setIsPrintView(true);
      });
    };

    const disablePrintView = (): void => {
      setIsPrintView(false);
    };

    window.addEventListener('beforeprint', enablePrintView);
    window.addEventListener('afterprint', disablePrintView);

    return (): void => {
      window.removeEventListener('beforeprint', enablePrintView);
      window.removeEventListener('afterprint', disablePrintView);
    };
  }, [printView]);

  const activeView = isPrintView ? printView : DEFAULT_VIEW;

  return <PrintViewContext.Provider value={activeView}>{children}</PrintViewContext.Provider>;
};

export default PrintViewProvider;
